import { module } from "angular";
import { duration, isDuration } from "moment-timezone";

export class TimeSpanInterceptorService {
    // Loose match, moment will check fully
    private static regexTimeSpan = /^(\d[. ])?\d{2}:\d{2}(:\d{2}(\.\d{1,6})?)?$/;

    public response = (responseData: any): any => {
        this.convertTimeSpanStringsToDurations(responseData);
        return responseData;
    };

    private convertTimeSpanStringsToDurations(input: any): void {
        if (input === null || typeof input !== "object") {
            return input;
        }

        // TODO: Rewrite for in loop
        // eslint-disable-next-line no-restricted-syntax
        for (const key in input) {
            if (!input.hasOwnProperty(key)) {
                continue;
            }
            const value = input[key];

            // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
            if (typeof value === "string" && value.match(TimeSpanInterceptorService.regexTimeSpan)) {
                const dur = duration(value);
                if (isDuration(dur)) {
                    input[key] = dur;
                }
            } else if (typeof value === "object") {
                this.convertTimeSpanStringsToDurations(value);
            }
        }
        return input;
    }
}

module("mmHttpInterceptors").service("timeSpanInterceptorService", TimeSpanInterceptorService);
